import { showErrorMessage } from "../helpers/messagesHelper";
import httpErrorMessage from "./httpErrorMessage";

function useErrorHandler() {
  return (error: any, setBackendFormErrors: any = null) => {
    const response = error?.response;

    // Sin response no hay status ni cuerpo que inspeccionar: la petición no llegó a
    // completarse (timeout del cliente, conexión abortada, red caída o CORS). Antes se
    // accedía directamente a error.response.status, así que en estos casos se lanzaba un
    // TypeError dentro del catch que llama a este handler y el usuario no recibía ningún
    if (!response) {
      showErrorMessage(httpErrorMessage(error));
      return;
    }

    // El cuerpo no siempre es el JSON esperado: ante un error del servidor puede llegar
    // HTML o una cadena vacía, así que nunca se asume que data sea un objeto.
    const data =
      typeof response.data === "object" && response.data !== null
        ? response.data
        : {};

    if (response.status === 401) {
      let message = data.error ? data.error : data.message;
      if (message === "Unauthenticated.") {
        // redirect to login without navigate
        window.location.href =
          "/login?message=Unauthenticated.&messageType=error";
      } else {
        showErrorMessage(message ?? "unauthorized_error");
      }
      return;
    }

    if (response.status === 422) {
      // setBackendFormErrors es opcional: buena parte de las llamadas (listados,
      // selectores, borrados) no tienen formulario donde pintar los errores y lo pasan
      // como null. Invocarlo a ciegas también rompía el handler.
      if (typeof setBackendFormErrors === "function") {
        setBackendFormErrors(formatErrors(data.errors ?? {}));
      }
      showErrorMessage("validation_errors");
      return;
    }

    showErrorMessage(httpErrorMessage(error));
  };
}

function formatErrors(errors: any) {
  let formattedErrors: any = {};
  for (let key in errors) {
    // si key no contiene un punto, es un error del formulario
    if (!key.includes(".")) {
      formattedErrors[key] = { __errors: errors[key] };
      continue;
    } else {
      // Tenemos que de forma dinamica sacar las keys de key separando por punto y setear el objeto de formattedErrores con las keys sacadas y en la ultima key guardar el error
      let keys = key.split(".");
      let lastKey = keys.pop();
      let currentObject = formattedErrors;
      keys.forEach((key) => {
        if (!currentObject[key]) {
          currentObject[key] = {};
        }
        currentObject = currentObject[key];
      });
      if (lastKey) {
        currentObject[lastKey] = { __errors: errors[key] };
      }
    }
  }
  return formattedErrors;
}

export default useErrorHandler;
